module.exports = __webpack_public_path__ + "static/img/dove.e7e4756a.png";